/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineObject16
 */
export interface InlineObject16 {
    /**
     * 
     * @type {number}
     * @memberof InlineObject16
     */
    aktid: number;
    /**
     * 
     * @type {string}
     * @memberof InlineObject16
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject16
     */
    transfercomment?: string;
}

export function InlineObject16FromJSON(json: any): InlineObject16 {
    return InlineObject16FromJSONTyped(json, false);
}

export function InlineObject16FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineObject16 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aktid': json['aktid'],
        'uid': json['uid'],
        'transfercomment': !exists(json, 'transfercomment') ? undefined : json['transfercomment'],
    };
}

export function InlineObject16ToJSON(value?: InlineObject16 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aktid': value.aktid,
        'uid': value.uid,
        'transfercomment': value.transfercomment,
    };
}


